import { render, staticRenderFns } from "./squareHostBottom.vue?vue&type=template&id=91143c5c&scoped=true&"
import script from "./squareHostBottom.vue?vue&type=script&lang=js&"
export * from "./squareHostBottom.vue?vue&type=script&lang=js&"
import style0 from "./squareHostBottom.vue?vue&type=style&index=0&id=91143c5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91143c5c",
  null
  
)

export default component.exports